export const NO_SEARCH_RESULTS = 'There are no results matching your search.<br>Please try again.';
export const NO_FILTER_RESULTS = 'There are no results matching your filters.<br>Please try again.';

export enum StorageKeys {
  DismissMfaEnrollment = 'DISMISS_MFA_ENROLLMENT',
}
